import { ParsedCookies, CookieOption } from './baseQueryWithReauth';

export function parseCookieHeader(headerString: string): ParsedCookies {
	const cookies: ParsedCookies = {};
	const cookieStrings = headerString.split(/,(?=\s*[^\s=]+=)/); // Split by comma, but not those within individual cookie strings.

	cookieStrings.forEach(cookieString => {
		const cookieParts = cookieString.split(';').map(part => part.trim());
		const [name, value] = cookieParts[0].split('=').map(part => decodeURIComponent(part.trim()));

		const cookieObj: CookieOption = {
			value
		};

		for (let i = 1; i < cookieParts.length; i++) {
			const [optionName, optionValue] = cookieParts[i].split('=').map(part => decodeURIComponent(part.trim()));

			switch (optionName.toLowerCase()) {
				case 'expires':
					cookieObj.expires = new Date(optionValue);
					break;
				case 'max-age':
					cookieObj.maxAge = parseInt(optionValue, 10);
					break;
				case 'domain':
				case 'path':
					cookieObj[optionName.toLowerCase() as 'domain' | 'path'] = optionValue;
					break;
				case 'secure':
					cookieObj.secure = true;
					break;
				case 'httponly':
					cookieObj.httpOnly = true;
					break;
				case 'samesite':
					cookieObj.sameSite = optionValue;
					break;
				default:
					// Handle potential extensions to the Set-Cookie header.
					cookieObj[optionName] = optionValue || true;
					break;
			}
		}
		cookies[name] = cookieObj;
	});

	return cookies;
}
